import React, { useState, useEffect } from "react";
import "../App.css";
import { useHistory } from "react-router-dom";
import { Button } from "reactstrap";
import user from "../assets/user.png";
import MyLoader from "./util/loader";
import MyStorage from "./util/storage";
import Api from "./api/api";
import { ToastContainer } from "react-toastify";

const Messages = () => {
  const history = useHistory();

  const [models, setModels] = useState([]);
  const [loader, setLoader] = useState(false);

  // load data
  useEffect(() => {
    setLoader(true);
    Api.getAllChats(
      (response) => {
        setLoader(false);
        if (response.status === "success") {
          setModels(response.data);
        }
      },
      (error) => {
        setLoader(false);
      }
    );
  }, []);


  console.log(models)

  const getProfilePhoto = (model) => {
    if (
      MyStorage.getFileUrls() == null ||
      model?.photo == null ||
      model?.photo === ""
    ) {
      return user;
    } else {
      if (model?.photo.includes("http")) {
        return model?.photo;
      }
      return MyStorage.getFileUrls().User + model?.photo;
    }
  };

  return (
    <div className="main">
      <div
        className="titlebar"
        style={{ backgroundColor: "#f2f2f2", padding: 10, margin: -15 }}
      >
        <div style={{ color: "blue" }}>Messages</div>
      </div>
      {/* <Button
                className='btn-block btn-submit'
                style={{ width: 150, borderWidth: 0, marginTop: 25, alignSelf: 'flex-start' }}
                onClick={() => {
                    console.log('click');
                    history.push({
                        pathname: '/chat',
                        state: { model: null }
                    })
                }}>
                Send Message
            </Button> */}

      <div style={{ marginTop: 30 }}></div>
      {models.map((model, index) => {
        let className =
          index % 2 !== 0 ? "projects-itembar" : "projects-itembar-colored";
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div className={className} style={{ marginTop: 0 }}>
              <div className="projects-item-photo">
                <img
                  src={getProfilePhoto(model?.user)}
                  style={{ padding: 1, width: 70, height: 70 }}
                />
              </div>
              <div className="projects-item-cat" style={{}}>
                <div
                  style={{
                    fontSize: 16,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {model?.user?.fname + " " + model?.user?.lname}
                  {"" + model?.unread === "0" ? null : (
                    <div
                      style={{
                        marginLeft: 10,
                        width: 20,
                        height: 20,
                        borderRadius: 10,
                        backgroundColor: "red",
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 12,
                      }}
                    >
                      {model?.unread}
                    </div>
                  )}
                </div>
                <div style={{ color: "green" }}>{"" + model?.last_message}</div>
              </div>

              <div
                className="projects-item-cat"
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Button
                  className="btn-block btn-submit"
                  style={{ width: 150, fontSize: 16 }}
                  onClick={() => {
                    console.log("click");
                    history.push({
                      pathname: "/chat",
                      state: { model: model },
                    });
                  }}
                >
                  Open Chat
                </Button>
              </div>
            </div>
          </div>
        );
      })}
      <MyLoader loader={loader} />
      <div>
        <ToastContainer />
      </div>
    </div>
  );
};

export default Messages;
